// extracted by mini-css-extract-plugin
export default {"button":"cjXcslrg3","bigger":"cfak0gP9m"};